import { compactMoney } from "../../../utils/directorFormat";

// Valor em reais compactos ("R$ 12,4 mi") com o valor exato no título acessível.
const Money = ({ cents, className }) => {
  const { text, title } = compactMoney(cents);
  return <span className={className} title={title ?? undefined}>{text}</span>;
};

export default Money;
